module.exports = __webpack_public_path__ + "static/media/Temple1.cf35d3c4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/Environments/Temple1.jpg
// module id = 216
// module chunks = 0